import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import api from '../../services/api';
import { hasScheduleRequest, getScheduleRequest } from '../../utils/scheduleUtils';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Container, Content, Form, FormGroup, Input, Button, Label, ErrorText } from './styles';

interface ICompleteRegistrationState {
  phone?: string;
  user_id?: string | number;
  requiresPhoneCompletion?: boolean;
  type?: 'tenant' | 'owner';
  token?: string;
}

export default function CompleteRegistration() {
  const history = useHistory();
  const { state } = useLocation<ICompleteRegistrationState>();
  const { completePhoneRegistration } = useAuth();

  const [inputPhone, setInputPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const tempToken = state?.token || localStorage.getItem('@7Cantos:tempToken');
    if (tempToken) {
      api.defaults.headers.authorization = `Bearer ${tempToken}`;
    }
  }, [state]);

  const tempUserId = state?.user_id || localStorage.getItem('@7Cantos:tempUserId');

  const redirectAfterRegistration = () => {
    if (hasScheduleRequest()) {
      const scheduleRequest = getScheduleRequest();
      if (scheduleRequest?.propertyId) {
        window.location.href = `/schedule/${scheduleRequest.propertyId}`;
        return;
      }
    }

    window.location.href = '/';
  };

  if (!tempUserId) {
    return (
      <Container>
        <Header />
        <Content>
          <h2>Dados Incompletos</h2>
          <p>Não conseguimos identificar seus dados. Tente fazer login novamente.</p>
          <Button onClick={() => history.push('/login')}>Voltar ao Login</Button>
        </Content>
        <Footer />
      </Container>
    );
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (!inputPhone.trim()) {
        setError('Telefone é obrigatório');
        setLoading(false);
        return;
      }

      const tempOtp = localStorage.getItem('@7Cantos:tempOtp');
      const tempToken = state?.token || localStorage.getItem('@7Cantos:tempToken');

      if (tempOtp) {
        await completePhoneRegistration({
          phone: inputPhone,
          otp: tempOtp,
          first_name: 'User',
          type: 'tenant'
        });

        localStorage.removeItem('@7Cantos:tempOtp');
        redirectAfterRegistration();
      } else if (tempUserId) {
        try {
          const response = await api.post('/api/auth/complete-registration', {
            user_id: tempUserId,
            phone: inputPhone
          });

          if (response.data.access_token) {
            localStorage.setItem('@7Cantos:token', response.data.access_token);
            api.defaults.headers.authorization = `Bearer ${response.data.access_token}`;

            const userResponse = await api.post('/api/auth/me');
            const userData = userResponse.data.data || userResponse.data;

            localStorage.setItem('@7Cantos:user', JSON.stringify(userData));

            const actualDate = new Date(Date.now());
            const dateToExpires = new Date(actualDate.getTime() + 24 * 60 * 60 * 1000);
            localStorage.setItem('@7Cantos:dateToExpires', dateToExpires.toString());
          } else {
            setError('Erro ao completar cadastro. Tente novamente.');
            setLoading(false);
            return;
          }

          localStorage.removeItem('@7Cantos:tempToken');
          localStorage.removeItem('@7Cantos:tempUserId');
          localStorage.removeItem('@7Cantos:tempPhone');

          redirectAfterRegistration();
        } catch (err: any) {
          setError(err.response?.data?.message || 'Erro ao completar cadastro. Tente novamente.');
          setLoading(false);
        }
      } else {
        setError('Sessão expirada. Tente fazer login novamente.');
        setLoading(false);
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erro ao completar cadastro');
      setLoading(false);
    }
  };

  return (
    <Container>
      <Header />
      <Content>
        <h2>Complete seu Cadastro</h2>
        <p>Digite seu telefone para finalizar o cadastro</p>

        <Form onSubmit={handleSubmit}>
          {error && <ErrorText>{error}</ErrorText>}

          <FormGroup>
            <Label htmlFor="phone">Telefone com WhatsApp *</Label>
            <Input
              id="phone"
              type="tel"
              value={inputPhone}
              onChange={(e) => setInputPhone(e.target.value)}
              placeholder="(11) 99999-9999"
              disabled={loading}
              required
            />
          </FormGroup>

          <Button type="submit" disabled={loading}>
            {loading ? 'Completando...' : 'Completar Cadastro'}
          </Button>
        </Form>
      </Content>
      <Footer />
    </Container>
  );
}